<template>
  <div>
    <ApprovalDocument
      :board="board"
      :value="form.body"

      @close="onClickClose"
      @delete="onClickDelete"
      @recall="onClickRecall"
      @print="onClickPrint"
      @tempsave="onClickTempsave"
      @retempsave="onClickReTempsave"
      @upload="onClickUpload"
      @ok="onClickOk"
      @no="onClickNo"
    >
      <template #header="props">
        <p class="h4 flex" style="align-items: center">
          가스 압력 기록
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.year" :readonly="true"/>년
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.month" :readonly="board.readonly"/>월
        </p>
      </template>

      <template #body="props">
        <div id="print">

          <!-- 기본정보 -->
          <m-group label="기본정보" :division="3">
            <m-form label="사업장명" :value="form.body.baseInfo.project_name" >
              <vs-input class="w-full" :readonly="true" v-model="form.body.baseInfo.project_name"/>
            </m-form>
            <m-form label="소속" :value="form.body.baseInfo.com_name" >
              <vs-input class="w-full" :readonly="true" v-model="form.body.baseInfo.com_name"/>
            </m-form>
            <m-form label="점검일자" :value="form.body.baseInfo.check_date" >
              <date-selector class="w-full" v-model="form.body.baseInfo.check_date" />
            </m-form>
            <m-form label="관리감독자" :value="form.body.baseInfo.supervisor" >
              <vs-input class="w-full" v-model="form.body.baseInfo.supervisor"/>
            </m-form>
            <m-form label="점검담당자" :value="form.body.baseInfo.manager" >
              <vs-input class="w-full" v-model="form.body.baseInfo.manager"/>
            </m-form>
          </m-group>
          <vs-row>
            <vs-col class="w-3/12 border-y border-left">
              <div class="table-header border-bottom"><span>명칭</span></div>
              <div class="p-1">
                <span v-if="isPrint">{{form.body.baseInfo.명칭}}</span>
                <vs-textarea v-else class="w-full m-0" v-model="form.body.baseInfo.명칭" style="resize: none;" :rows="3" />
              </div>
            </vs-col>
            <vs-col class="w-2/12 border-y border-left">
              <div class="table-header border-bottom"><span>측정기간</span></div>
              <div class="grid p-1" style="align-items: center;">
                <m-form class="w-full py-1" label="시작일" label-width="50px" :value="form.body.baseInfo.측정시작일">
                  <date-selector v-model="form.body.baseInfo.측정시작일" />
                </m-form>
                <m-form class="w-full mt-auto py-1" label="종료일" label-width="50px" :value="form.body.baseInfo.측정종료일">
                  <date-selector v-model="form.body.baseInfo.측정종료일" />
                </m-form>
              </div>
            </vs-col>
            <vs-col class="w-1/12 border-y border-left">
              <div class="table-header border-bottom"><span>이상여부</span></div>
              <div style="display: grid; justify-content: center; align-items: center;">
                <span v-if="isPrint && form.body.baseInfo.정상">정상</span>
                <vs-checkbox v-if="!isPrint" class="mt-8" v-model="form.body.baseInfo.정상" @change="(value)=> {
                  form.body.baseInfo.이상 = false;
                }">정상</vs-checkbox>
                <span v-if="isPrint && form.body.baseInfo.이상">이상</span>
                <vs-checkbox v-if="!isPrint" v-model="form.body.baseInfo.이상" @change="(value)=> {
                  form.body.baseInfo.정상 = false;
                }">이상</vs-checkbox>
              </div>
            </vs-col>
            <vs-col class="w-3/12 border-y border-left">
              <div class="table-header border-bottom"><span>조치사항</span></div>
              <div class="p-1">
                <span v-if="isPrint">{{ form.body.baseInfo.조치사항 }}</span>
                <vs-textarea v-else class="w-full m-0" style="resize: none;" :rows="3" v-model="form.body.baseInfo.조치사항"/></div>
            </vs-col>
            <vs-col class="w-3/12 border-y border-x">
              <div class="table-header border-bottom"><span>비고</span></div>
              <div class="p-1">
                <span v-if="isPrint">{{ form.body.baseInfo.비고 }}</span>
                <vs-textarea v-else class="w-full m-0" style="resize: none;" :rows="3" v-model="form.body.baseInfo.비고"/></div>
            </vs-col>
          </vs-row>

          <!-- 가스 압력 기록 결과 -->
          <m-title style="margin-top: 2rem; " label="가스 압력 기록 결과" >
            <template slot="right">
              <feather-icon icon="AlertCircleIcon" style="width:18px; margin-right: 4px; "/>
              <span style="font-size: 14px;">1MB 이하의 이미지형식(JPG, PNG 등) 파일만 업로드 가능합니다</span>
            </template>
          </m-title>
          <div style="position: relative; width: 100%; margin: 0 auto;">
            <div style="padding-top: 100%;">
              <file-uploader style="position: absolute; top:0;" type="only-image" class="w-full h-full" v-model="form.body.가스압력기록결과" />
            </div>
          </div>

          <!-- 첨부파일 -->
          <file-upload-module class="w-full" style="margin-top: 2rem;" v-model="fileList"></file-upload-module>
        </div>
      </template>

    </ApprovalDocument>
  </div>
</template>

<script>
import ApprovalDocument from '@/views/write/document/ApprovalDocument'
import Template from '@/views/admin/approval/Template'
import SafetyAccidentBasicData from '@/views/content/safety/SafetyAccidentBasicData'
import SafetyCheckBasicInfo from '@/views/write/safetycheck/components/SafetyCheckBasicInfo'
import MGroup from '@/components/base-ui/MGroup'
import MForm from '@/components/base-ui/MForm'
import MTitle from '@/components/base-ui/MTitle'
import MCheckTable from '@/components/base-ui/MCheckTable'
import CheckTableHeader from '@/views/write/safetycheck/firefighting_self_check/component/CheckTableHeader'
import CheckTableBodyItem from '@/views/write/safetycheck/firefighting_self_check/component/CheckTableBodyItem'
import FileUploadModule from '@/views/modules/FileUploadModule'
import DateSelector from '@/views/components/DateSelector'
import FileUploader from '@/views/components/FileUploader'

export default {
  name: 'GasPressureCheck',
  components: {
    FileUploader,
    DateSelector,
    FileUploadModule,
    CheckTableBodyItem,
    CheckTableHeader,
    MCheckTable,
    MTitle,
    MForm,
    MGroup,
    SafetyCheckBasicInfo,
    SafetyAccidentBasicData,
    Template,
    ApprovalDocument},
  data () {
    return {
      isPrint: false,

      // TODO : 글쓰기 정보 및 권한
      board: {
        slug: this.boardSlug,
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine: [], // 결재라인
        commentList: [] // 댓글리스트
      },

      form: {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1
        },
        body: {
          baseInfo: {
            project_name: this.projName,
            com_name: this.comName,
            check_date: '',
            supervisor: '',
            manager: '',
            workTypeTitleList: ['소화설비', '경보설비', '피난설비', '소화용수설비', '소화활동설비', '기타'],
            workType: [false, false, false, false, false, false],
            명칭: '',
            측정시작일: '',
            측정종료일: '',
            정상: false,
            이상: false,
            조치사항: '',
            비고: ''
          },
          가스압력기록결과 : {},
        }
      },

      fileList: [],
      test: 'test',
    }
  },
  computed:{
    selectedWorkTypeList () {
      let selected = ''
      let count = 0
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          if (count > 0) {
            selected += ', '
          }
          selected += this.form.body.baseInfo.workTypeTitleList[i]
          count++
        }
      }
      return selected
    },
    isUpdateMode () {
      return this.$route.params.postId
    },
    boardSlug () {
      return this.$route.params.boardSlug
    },
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    menuA () {
      const menus = []
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          menus.push(this.form.body.baseInfo.workTypeTitleList[i])
        }
      }
      return menus
    },
    menuResults () {
      return ['적합', '부적합', 'N/A']
    },
    comName () {
      if (this.isUpdateMode) {
      } else {
        return this.$store.state.company.companyInfo.com_name;
      }
    },
    projName () {
      return this.$store.state.project.projectInfo.field_name;
    }
  },
  watch: {
    'comName' (value) {
      this.form.body.baseInfo.com_name = value;
    },
    'projName' (value) {
      this.form.body.baseInfo.project_name = value;
    }
  },
  mounted () {
    this.board.slug = this.boardSlug

    if (this.comName) {
      this.form.body.baseInfo.com_name = this.comName
    }
    if (this.projName) {
      this.form.body.baseInfo.project_name = this.projName
    }

    if (this.isUpdateMode) {
      this.loadPost()
    }
  },
  methods: {

    async loadPost () {
      const boardSlug = this.$route.params.boardSlug
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/LOAD_POST', {
        boardSlug,
        postId
      })

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }

      // 내용
      const post = JSON.parse(this.$store.state.approval.postInfo.post_content)
      this.form = post

      const files = this.$store.state.approval.postInfo.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id: file.id,
            fileName: file.file_name,
            fileSize: file.file_size,
            path: file.path,
            thumb: file.thumb
          })
        }
      }

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.slug = this.boardSlug
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))
      this.board.readonly = !(this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.collection = this.board.isWriter && (this.board.statusCode === 'registered')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
    },

    convertFileListToApiFiles () {
      let uploads = '[]'
      const uploadFileIds = []

      if (this.fileList && this.fileList.length > 0) {
        for (const file of this.fileList) {
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      return uploads
    },

    getOptions (option) {
      const projectId = parseInt(this.$route.params.proj_id)

      const content = JSON.stringify(this.form)
      const uploads = this.convertFileListToApiFiles()

      return {
        projectId,
        content,
        uploads,
        ...option
      }
    },

    async sendUpload (option) {
      if (this.isUpdateMode) {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp:'y', ...this.getOptions(option)})
      } else {
        await this.$store.dispatch('approval/CREATE_POST', {...this.getOptions(option)})
      }
      alert('상신되었습니다.')
      this.onClickClose()
    },
    async sendTemp (option, isCreate) {
      // 임시 저장하기
      if (isCreate || !this.isUpdateMode) {
        await this.$store.dispatch('approval/CREATE_POST', {isTemp: 1, ...this.getOptions(option)})
      } else {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp: 'n', ...this.getOptions(option)})
      }
      alert('임시저장되었습니다.')
      this.onClickClose()
    },

    onChangeInput (value, files) {
      this.form.body = value
      this.fileList = files
    },

    onClickClose () {
      // 닫기
      this.$router.back()
    },
    async onClickDelete () {
      // 삭제
      if (confirm('삭제하시겠습니까?')) {
        const boardSlug = this.boardSlug
        const postId = this.$route.params.postId
        await this.$store.dispatch('approval/DELETE_POST', {boardSlug, postId})
        this.oldForm = this.form
        this.onClickClose()
      }
    },
    onClickPrint () {
      // 프린트
      this.isPrint = true
      this.$store.commit('ui/SET_IS_PRINT', true)

      setTimeout(() => {
        const g_oBeforeBody = document.getElementById('print').innerHTML
        const g_oBeforeApproval = document.getElementById('print-approval').innerHTML
        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = '#fff'
          document.body.innerHTML = `${g_oBeforeBody}<br>${g_oBeforeApproval}`
        }
        window.print()
        location.reload()
      }, 300)
    },
    async onClickRecall (option) {
      // 결재문서 회수
      if (confirm('회수 후 임시저장 상태로 변경하시겠습니까?')) {
        await this.sendTemp(option)
      }
    },
    async onClickTempsave (option) {
      // 임시 저장하기
      await this.sendTemp(option)
    },
    async onClickReTempsave (option) {
      // 재상신
      await this.sendTemp(option, true)
    },
    async onClickUpload (option) {
      // 상신
      await this.sendUpload(option)
    },
    async onClickOk () {
      // 승인
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {postId})
      this.onClickClose()
    },
    async onClickNo (text) {
      // 반려
      const postId = parseInt(this.$route.params.postId)
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', { postId, comment })
      this.onClickClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.table-header {
  display: flex; justify-content: center; align-items: center;
  min-height: 50px;
  background-color: #f9f9f9;
}
</style>
